// src/components/gear/GearStatsRow.jsx

import React from "react";

export default function GearStatsRow({ stats, loading, onSelect }) {
  const totalAssets = stats?.totalAssets ?? stats?.total ?? 0;
  const openActions = stats?.openActions ?? stats?.actionsOpen ?? 0;
  const inspections30 = stats?.inspectionsLast30Days ?? stats?.inspections30Days ?? 0;

  const items = [
    { key: "assets", label: "Total assets", value: totalAssets },
    { key: "actions", label: "Open actions", value: openActions },
    { key: "inspections", label: "Inspections (30 days)", value: inspections30 },
  ];

  return (
    <div className="grid grid-cols-3 gap-2 sm:gap-3 mb-4 md:mb-0">
      {items.map((it) => {
        const clickable = typeof onSelect === "function" && !loading;
        return (
          <button
            key={it.label}
            type="button"
            onClick={() => clickable && onSelect(it.key)}
            className={
              "text-left bg-white border border-gray-200 rounded-xl shadow-sm transition " +
              (clickable ? "hover:bg-gray-50 hover:border-gray-300 cursor-pointer " : "cursor-default ") +
              "p-3 sm:p-4"
            }
          >
            <div className="text-[11px] sm:text-xs text-gray-500 font-semibold leading-tight">
              {it.label}
            </div>
            <div className="text-lg sm:text-2xl font-semibold mt-1">
              {loading ? "—" : it.value}
            </div>
          </button>
        );
      })}
    </div>
  );
}
